import PageLayout from "@/components/site/PageLayout";
import PageHeader from "@/components/site/PageHeader";
import AreasServed from "@/components/site/AreasServed";
import CTABand from "@/components/site/CTABand";
import SEO from "@/components/site/SEO";

export default function AreasPage() {
  return (
    <PageLayout testid="areas-page">
      <SEO
        title="Areas We Serve in Hyderabad | Sudeeksha Invisible Grills"
        description="Invisible grill installation across Hyderabad — Gachibowli, Kondapur, Madhapur, Hitech City, Kukatpally, Financial District, Kokapet and more."
        path="/areas"
      />
      <PageHeader
        eyebrow="Coverage"
        title={["Areas We", "Serve"]}
        crumb="Areas We Serve"
        subtitle="From IT-corridor high-rises to gated communities, our crews install across Hyderabad. Tap your locality for area-specific details."
      />
      <AreasServed />
      <CTABand />
    </PageLayout>
  );
}
